import Flux from 'lib/flux';
import ConversationService from 'services/conversation';
import ConversationConstants from 'constants/conversation';

const ConversationActionCreator = Flux.createActionCreator({
  create_from_booking(params, successCallback, failureCallback) {
    this.dispatchAction(ConversationConstants.CREATE);

    ConversationService.create_from_booking(params).then(
      (resp) => {
        this.dispatchAction(ConversationConstants.CREATE_COMPLETED, resp);
        successCallback(resp);
      },
      (errors) => {
        this.dispatchAction(ConversationConstants.CREATE_FAILED, errors);
        failureCallback(errors.message);
      }
    );
  },
});

export default ConversationActionCreator;
